export default __webpack_public_path__ + "static/media/chairJumpThumb.67f66e62.png";